import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const TawkToScript = () => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_LoadStart = new Date();
            const s1 = document.createElement("script");
            const s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/6667e734981b6c56477bcf08/1i02tu9kk';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        }
    }, []);

    return (
        <Helmet>
            <script>
                {`
                    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                `}
            </script>
        </Helmet>
    );
};

export default TawkToScript;
